import { DASHBOARD_PATH, SALES_REPORT_PATH, SUMMARY_PATH } from "lib"
import SaleReportGrid from "pages/DashboardViews/SaleReportGrid"
import SummaryReport from "pages/DashboardViews/SammaryReport"
import React from "react"
import { Route } from "react-router-dom"

const Dashboards = () => {
  return (
    <React.Fragment>
      <Route
        strict
        path={`${DASHBOARD_PATH}${SALES_REPORT_PATH}`}
        component={() => <SaleReportGrid />}
      />

      <Route
        strict
        path={`${DASHBOARD_PATH}${SUMMARY_PATH}`}
        component={() => <SummaryReport />}
      />
    </React.Fragment>
  )
}

export default Dashboards
